<template>
  <v-container fluid>
    <v-row>
      <!-- Profile Card Column -->
      <v-col cols="12" md="6" lg="5">
        <v-card max-width="450" class="mx-auto bg" elevation="2">   
          <v-img class="d-flex justify-center" height="60" src="img/idcard_head.jpg"></v-img>   
          <v-row justify="center">
            <v-col align-self="start" class="d-flex justify-center align-center pa-0 mt-5" cols="12">
              <v-avatar class="profile avatar-center-height avatar-shadow" color="grey" rounded="1" size="150">         
                <v-img class="d-flex justify-center" :src="userProfile.USER_IMAGE"></v-img>      
              </v-avatar>        
            </v-col>
            <h5 class="text-h5 mt-3 wrap">{{ user.USER_NAME }}</h5>
          </v-row>
          <v-list-item color="#0000" class="profile-text-name ma-4 pt-7">
            <v-list-item-content class="text-center">
              <v-list-item-subtitle>{{ userProfile.DESIG_DESC }}</v-list-item-subtitle>
              <v-list-item-subtitle>{{ userProfile.PDEPTMST_DESC }} Dept.</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-card-subtitle class="d-flex justify-center">
            <div class="card">
              <div class="card-body">
                <canvas ref="canvas" />
              </div>
            </div>  
          </v-card-subtitle>    
          <v-row>
            <v-col cols="6" class="text-end">
              <v-list-item-content class="subtitles">
                <v-list-item-title class="text-h6">Emp No :</v-list-item-title>
                <v-list-item-subtitle class="text-caption">Gender :</v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">Joining Date :</v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">Nationality :</v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">Phone :</v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">Email :</v-list-item-subtitle>
              </v-list-item-content>
            </v-col>
            <v-col cols="6" class="text-start">
              <v-list-item-content class="subtitles">
                <v-list-item-title class="text-h6">{{ userProfile.EMPMST_DOCNO }}</v-list-item-title>
                <v-list-item-subtitle class="text-caption">{{ userProfile.EMPMST_GENDER }}</v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">{{ formatDate(userProfile.EMPMST_JOIN_DATE) }}</v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">{{ userProfile.CM_DESC }}</v-list-item-subtitle>   
                <v-list-item-subtitle class="text-caption">{{ userProfile.EMPMST_TEL2 }}</v-list-item-subtitle>
                <v-list-item-subtitle class="text-caption">{{ userProfile.EMPMST_EMAIL }}</v-list-item-subtitle>    
              </v-list-item-content>
            </v-col>
          </v-row>   
        </v-card>
      </v-col>
      
      <!-- Form Card Column -->
      <v-col cols="12" md="6" >
        <v-card class="mx-auto" elevation="2">
          <v-card-title class="text-h5 font-weight-bold">Update Profile</v-card-title>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="formData.name"
                :rules="nameRules"
                label="Name"
                required
                disabled
              ></v-text-field>
              
              <v-text-field
                v-model="formData.email"
                :rules="emailRules"
                label="E-mail"
                required
              ></v-text-field>
              
              <v-text-field
                v-model="formData.phone"
                :rules="phoneRules"
                label="Phone"
                required
              ></v-text-field>
              
              <!-- <v-select
                v-model="formData.department"
                :items="departments"
                :rules="[v => !!v || 'Department is required']"
                label="Department"
                required
              ></v-select>
              
              <v-textarea
                v-model="formData.about"
                label="About Me"
                rows="3"
              ></v-textarea>
               -->
              <v-btn
                color="primary"
                class="mr-4"
                @click="submitForm"
                :disabled="!valid"
              >
                Update Profile
              </v-btn>
              
              <v-btn
                color="error"
                class="mr-4"
                @click="resetForm"
              >
                Reset Form
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import QRCode from 'qrcode'
import moment from 'moment'

export default {
  name: 'MyProfile',
  data() {
    return {
      valid: true,
      formData: {
        name: '',
        email: '',
        phone: '',
        department: '',
        about: ''
      },
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 50) || 'Name must be less than 50 characters'
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      phoneRules: [
        v => !!v || 'Phone is required',
        v => /^\d{10}$/.test(v) || 'Phone must be 10 digits'
      ],
      departments: ['IT', 'HR', 'Finance', 'Marketing', 'Operations']
    }
  },
  computed: {
    user() {     
      return this.$store.getters.factsuser      
    },
    userProfile() {
      return this.$store.getters.userProfile
    }
  },
  methods: {
    get_profile() {
      this.$store.dispatch("get_employee", { employ_id: this.user.USER_EMP_DOCNO })
    },
    formatDate(d) {
      return moment(d).format('DD-MM-YYYY').toString()
    },
    async generateQRCode() {
      const canvas = this.$refs.canvas
      const url = this.user.USER_UD_LABEL10

      await QRCode.toCanvas(canvas, url, {
        width: 128,
        color: {
          dark: '#0365af',
          background: '#ffffff'
        }
      })
    },
    submitForm() {
      if (this.$refs.form.validate()) {
        // Handle form submission
        console.log('Form submitted:', this.formData)
        // You can add your API call or state update logic here
      }
    },
    resetForm() {
      this.$refs.form.reset()
    }
  },
  created() {
    this.get_profile()
  },
  mounted() {
    this.generateQRCode()
  }
}
</script>

<style scoped>
.bg {
  background: radial-gradient(circle at center -12%, rgba(141, 186, 223, 0.712) 45%, rgba(105, 153, 232, 0.667) 5%, rgba(179, 212, 227, 0.754) 74%);
}

.avatar-shadow {
  box-shadow: 0px 0px 10px 0px rgba(50,12,112,0.75);
}

.card {
  width: 120px;
  height: 120px;
}

.card-body {
  display: flex;
  justify-content: center;
  align-items: center;
}

canvas {
  width: 100px;
  height: 100px;
}
</style>